const stripTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const resolveUserProfileBaseUrl = () => {
    const envBase = String(process.env.REACT_APP_WEB_BASE_URL || '').trim();
    if (envBase) return stripTrailingSlash(envBase);

    if (typeof window !== 'undefined' && window.location?.origin) {
        return stripTrailingSlash(window.location.origin);
    }

    return '';
};

export const buildUserProfileQrData = (userId: string, baseUrl = resolveUserProfileBaseUrl()) => {
    const normalizedUserId = String(userId || '').trim();
    const normalizedBaseUrl = stripTrailingSlash(String(baseUrl || '').trim());

    if (!normalizedUserId || !normalizedBaseUrl) return '';

    return `${normalizedBaseUrl}/user/${normalizedUserId}`;
};
